import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Actions
import { deleteWebhook } from '~/redux/actions/webhooks-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';

// Components
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import { ModalTrashIcon } from '~/assets/images';

const DeleteWebhookModal = (props) => {
  const { openModal, handleCloseModal, selectedWebhook } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await dispatch(deleteWebhook(selectedWebhook));
      dispatch(success(response.data.message));
      handleCloseModal();
      navigate('/settings/webhooks');
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || MESSAGES.GENERAL_ERROR));
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header: MESSAGES.SETTINGS.WEBHOOKS.DELETE.TITLE,
        message: MESSAGES.SETTINGS.WEBHOOKS.DELETE.HEADING,
        description: MESSAGES.SETTINGS.WEBHOOKS.DELETE.DESCRIPTION,
        icon: ModalTrashIcon,
        handleOk: handleDelete,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.SETTINGS.WEBHOOKS.DELETE.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.SETTINGS.WEBHOOKS.DELETE.CANCEL_BUTTON,
      }}
    />
  );
};

export default DeleteWebhookModal;
